
import ForumPostDetail from '../../components/ForumPostDetail';

export default function GeneralDetailPage() {
  return <ForumPostDetail categoryId="general" />;
}
